import React from 'react';
import { platformLogoMap } from './platformDefinitions';

interface ImageLabelProps {
    label: string;
    platformLabel: string;
    aspectRatio: string;
}

const ImageLabel: React.FC<ImageLabelProps> = ({
    label,
    platformLabel,
    aspectRatio,
}) => {
    const logoSrc = platformLogoMap[platformLabel];

    return (
        <div className="absolute bottom-2 left-2 z-20 flex items-center pointer-events-none">
            <div className="flex items-center gap-1.5 bg-black/60 backdrop-blur-sm rounded-md px-2 py-1 max-w-[90%]">
                {logoSrc && (
                    <img
                        src={logoSrc}
                        alt={platformLabel}
                        className="w-4 h-4 object-contain rounded-sm"
                    />
                )}
                <span className="text-white text-xs truncate">{label}</span>
                {aspectRatio && (
                    <span className="text-white/60 text-xs flex-shrink-0">({aspectRatio})</span>
                )}
            </div>
        </div>
    );
};

export default ImageLabel;
